var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ordinaryBill" },
    [
      _c(
        "div",
        { staticClass: "y-pl-20 y-pt-20 y-pr-20 clearfix" },
        [
          _c(
            "el-form",
            { ref: "searchForm", attrs: { inline: true, model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "createTime", label: "账单生成时间" } },
                [
                  _c("yto-date-picker", {
                    attrs: {
                      size: "mini",
                      clearable: false,
                      "picker-options": _vm.pickerOptions,
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.form.createTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "createTime", $$v)
                      },
                      expression: "form.createTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "customerCode", label: "客户编码" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "y-w-200",
                      attrs: { size: "mini", placeholder: "请选择" },
                      model: {
                        value: _vm.form.customerCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "customerCode", $$v)
                        },
                        expression: "form.customerCode",
                      },
                    },
                    _vm._l(_vm.kCodeOpts, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label: item.code + "--" + item.name,
                          value: item.code,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "billingStatus", label: "对账状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "y-w-200",
                      attrs: { size: "mini", placeholder: "请选择" },
                      model: {
                        value: _vm.form.billingStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "billingStatus", $$v)
                        },
                        expression: "form.billingStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部", value: "-1" },
                      }),
                      _c("el-option", {
                        attrs: { label: "待确认", value: "0" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已确认", value: "1" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已申诉", value: "2" },
                      }),
                      _c("el-option", {
                        attrs: { label: "申诉驳回", value: "3" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { staticClass: "y-f-r" }, [
                _c(
                  "div",
                  { staticClass: "button-group" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.resetForm("searchForm")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "y-h-10 y-bk-F0F2F8" }),
      _c(
        "div",
        { staticClass: "y-pd-20" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "汇总", name: "summary" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "y-mb-10",
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled: _vm.total == 0,
                      },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v(" 导出 ")]
                  ),
                  _c("span", { staticClass: "y-fs-12 y-ml-10" }, [
                    _c("i", {
                      staticClass: "el-icon-warning y-fc-4C84FF y-fs-14",
                    }),
                    _vm._v(
                      " 账单由合作网点推送后才可查询，可点击账单编号查看账单明细或进行对账申诉，账单无异议的请及时确认账单 "
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        icon: "el-icon-s-tools",
                      },
                      on: { click: _vm.tableConfig },
                    },
                    [_vm._v("自定义列")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.autoVerifyBill("summary")
                        },
                      },
                    },
                    [_vm._v("自动对账")]
                  ),
                  _vm.activeName == "summary" && _vm.showTable
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          key: "summary",
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.summaryData,
                            "default-sort": {
                              prop: "createTime",
                              order: "descending",
                            },
                          },
                          on: {
                            "selection-change": _vm.handleSelectionChange,
                            "sort-change": _vm.sortChange,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: !(
                                              scope.row.billingStatus == "0" ||
                                              scope.row.billingStatus == "3"
                                            ),
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmBill(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("确认账单")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2857089237
                            ),
                          }),
                          _vm._l(
                            _vm.tableConfigHeadList,
                            function (item, index) {
                              return [
                                item.enName == "billingNo"
                                  ? _c(
                                      "el-table-column",
                                      {
                                        key: item.enName + index,
                                        attrs: {
                                          "min-width": "100px",
                                          prop: item.enName,
                                          label: item.cnName,
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "y-fc-4C84FF y-c-p",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleClick(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.billingNo
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "header" },
                                          [
                                            _c("check-down", {
                                              attrs: {
                                                title: item.cnName,
                                                checkBoxList: _vm.allbillList,
                                                defaultCheckBoxList:
                                                  _vm.billingNoLst,
                                              },
                                              on: { checked: _vm.checkedOrder },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  : _c("el-table-column", {
                                      key: item.enName + index,
                                      attrs: {
                                        "min-width":
                                          item.cnName && item.cnName.length > 4
                                            ? "120px"
                                            : "100px",
                                        prop: item.enName,
                                        label: item.cnName,
                                        align: "center",
                                        sortable: _vm.tableSortList.includes(
                                          item.enName
                                        ),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                item.cnName == "申诉明细"
                                                  ? [
                                                      scope.row.billingStatus ==
                                                        "2" ||
                                                      scope.row.billingStatus ==
                                                        "3"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "y-fc-4C84FF y-c-p",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.complaintDetails(
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("查看")]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  : item.enName ==
                                                      "startTime" ||
                                                    item.enName == "endTime" ||
                                                    item.enName == "createTime"
                                                  ? [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFilter"
                                                            )(
                                                              scope.row[
                                                                item.enName
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[
                                                              item.enName
                                                            ]
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                              ]
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "y-mt-20" },
                    [
                      _c("el-pagination", {
                        staticClass: "y-t-ac",
                        attrs: {
                          "current-page": _vm.pageNo,
                          "page-sizes": [10, 20, 50],
                          "page-size": _vm.limit,
                          layout: "total, sizes, prev, pager, next",
                          total: _vm.total,
                        },
                        on: {
                          "size-change": _vm.limitChange,
                          "current-change": _vm.pageChange,
                          "update:currentPage": function ($event) {
                            _vm.pageNo = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.pageNo = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "明细", name: "detail" } },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: true } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "运单号" } },
                        [
                          _c("el-input", {
                            staticClass: "y-w-180",
                            attrs: {
                              placeholder: "输入运单号查询",
                              size: "mini",
                              clearable: "",
                            },
                            model: {
                              value: _vm.inputWaybillNo,
                              callback: function ($$v) {
                                _vm.inputWaybillNo = $$v
                              },
                              expression: "inputWaybillNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.handleSearchWay },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "normal-btn",
                              attrs: {
                                size: "mini",
                                disabled: _vm.detailTotal == 0,
                              },
                              on: { click: _vm.exportDetailData },
                            },
                            [_vm._v("导出")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-s-tools",
                              },
                              on: { click: _vm.tableConfig },
                            },
                            [_vm._v("自定义列")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticStyle: { float: "right" } },
                        [
                          _vm.detailData &&
                          _vm.detailData.length &&
                          _vm.curRow &&
                          _vm.curRow.billingStatus != "1"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.autoVerifyBill },
                                },
                                [_vm._v("自动对账")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.activeName == "detail" && _vm.showTable
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          key: "detail",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.detailData,
                            "default-sort": {
                              prop: "createTime",
                              order: "descending",
                            },
                            "show-summary": "",
                            "summary-method": _vm.getSummaries,
                          },
                          on: { "sort-change": _vm.sortChangeByDetail },
                        },
                        [
                          _vm._l(
                            _vm.tableConfigHeadList,
                            function (item, index) {
                              return [
                                item.enName == "provinceName"
                                  ? _c(
                                      "el-table-column",
                                      {
                                        key: item.enName + index,
                                        attrs: {
                                          "min-width": "100px",
                                          prop: item.enName,
                                          label: item.cnName,
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row[item.enName]
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "header" },
                                          [
                                            _c("check-down", {
                                              attrs: {
                                                title: item.cnName,
                                                checkBoxList:
                                                  _vm.allProvinceList,
                                                defaultCheckBoxList:
                                                  _vm.provinceLst,
                                              },
                                              on: {
                                                checked: _vm.checkedProvince,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  : _c("el-table-column", {
                                      key: item.enName + index,
                                      attrs: {
                                        "min-width":
                                          item.cnName && item.cnName.length > 4
                                            ? "120px"
                                            : "100px",
                                        prop: item.enName,
                                        label: item.cnName,
                                        align: "center",
                                        sortable:
                                          _vm.tableSortListByDetail.includes(
                                            item.enName
                                          ),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                item.enName == "createTime"
                                                  ? [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFilter"
                                                            )(
                                                              scope.row[
                                                                item.enName
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[
                                                              item.enName
                                                            ]
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                              ]
                            }
                          ),
                          _vm.tableHeaderList.includes("ioTypeName")
                            ? _c("el-table-column", {
                                attrs: {
                                  "min-width": "100px",
                                  prop: "ioTypeName",
                                  label: "重量取值来源",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("billingTime")
                            ? _c("el-table-column", {
                                attrs: { label: "计费时间", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("dateFilter")(
                                                  scope.row.billingTime
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  968609006
                                ),
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("transFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "transFee",
                                  label: "运费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("addAmount")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "addAmount",
                                  label: "加收费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("extend7")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "extend7",
                                  label: "面单费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("optFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "optFee",
                                  label: "操作费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("aidDeliveryFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  "min-width": "100px",
                                  prop: "aidDeliveryFee",
                                  label: "扶持派送费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("extraFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "extraFee",
                                  label: "附加费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("optWeightFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "optWeightFee",
                                  label: "计重费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("overweightFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "overweightFee",
                                  label: "超重派送费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("hqFee")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "hqFee",
                                  label: "总部成本",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("yqAddAmount")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "yqAddAmount",
                                  label: "附加费出港",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("ultFeeAmt")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "ultFeeAmt",
                                  label: "超区件",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("backReverseAmt")
                            ? _c("el-table-column", {
                                attrs: {
                                  "min-width": "100px",
                                  prop: "backReverseAmt",
                                  label: "退回逆向费用",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("bsBackAmt")
                            ? _c("el-table-column", {
                                attrs: {
                                  "min-width": "100px",
                                  prop: "bsBackAmt",
                                  label: "退回件服务费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("yzdAmt")
                            ? _c("el-table-column", {
                                attrs: {
                                  "min-width": "100px",
                                  prop: "yzdAmt",
                                  label: "圆准达服务费",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("senderName")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "senderName",
                                  label: "寄件人姓名",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("senderAddress")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "senderAddress",
                                  label: "寄件人地址",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("receiverName")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "receiverName",
                                  label: "收件人姓名",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("receiverAddress")
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "receiverAddress",
                                  label: "收件人地址",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                          _vm.tableHeaderList.includes("isReturn")
                            ? _c("el-table-column", {
                                attrs: {
                                  "min-width": "100px",
                                  prop: "isReturn",
                                  label: "是否更址/退回",
                                  align: "center",
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "y-mt-20" },
                    [
                      _c("el-pagination", {
                        staticClass: "y-t-ac",
                        attrs: {
                          "current-page": _vm.detailPageNo,
                          "page-sizes": [10, 20, 50],
                          "page-size": _vm.detailLimit,
                          layout: "total, sizes, prev, pager, next",
                          total: _vm.detailTotal,
                        },
                        on: {
                          "size-change": _vm.detailLimitChange,
                          "current-change": _vm.detailPageChange,
                          "update:currentPage": function ($event) {
                            _vm.detailPageNo = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.detailPageNo = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申诉明细",
            visible: _vm.dialogTableVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "运单号" } },
                [
                  _c("el-input", {
                    staticClass: "y-w-180",
                    attrs: { placeholder: "输入运单号查询", size: "mini" },
                    model: {
                      value: _vm.dialogWaybillNo,
                      callback: function ($$v) {
                        _vm.dialogWaybillNo = $$v
                      },
                      expression: "dialogWaybillNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.dialogPageChange(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              staticClass: "y-mb-20",
              attrs: { data: _vm.dialogData },
            },
            [
              _c("el-table-column", {
                attrs: {
                  property: "waybillNo",
                  label: "运单号码",
                  align: "center",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  property: "weight",
                  label: "计费重量",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  property: "province",
                  label: "计费省份",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  property: "differenceName",
                  label: "差异类型",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  property: "differenceContent",
                  label: "差异内容",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  property: "complaintStatusName",
                  label: "申诉处理状态",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.complaintStatusName == "已驳回"
                          ? _c("span", { staticClass: "y-fc-F32F52" }, [
                              _vm._v(_vm._s(scope.row.complaintStatusName)),
                            ])
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.complaintStatusName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  property: "rejectedReason",
                  label: "驳回原因",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.rejectedReason) + " "),
                        scope.row.rejectedPics && scope.row.rejectedPics.length
                          ? [
                              _vm._l(
                                scope.row.rejectedPics,
                                function (item, index) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        key: item,
                                        staticClass:
                                          "y-ml-10 y-fc-4C84FF y-c-p",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toShowImg(item)
                                          },
                                        },
                                      },
                                      [_vm._v("图片" + _vm._s(index + 1))]
                                    ),
                                  ]
                                }
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "y-t-ac",
            attrs: {
              "current-page": _vm.dialogPageNo,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.dialogLimit,
              layout: "total, sizes, prev, pager, next",
              total: _vm.dialogTotal,
            },
            on: {
              "size-change": _vm.dialogLimitChange,
              "current-change": _vm.dialogPageChange,
              "update:currentPage": function ($event) {
                _vm.dialogPageNo = $event
              },
              "update:current-page": function ($event) {
                _vm.dialogPageNo = $event
              },
            },
          }),
          _c(
            "el-dialog",
            {
              staticClass: "imgDialog",
              attrs: {
                visible: _vm.dialogVisible,
                title: "图片",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.closeImg,
              },
            },
            [
              _c("div", [
                _c("img", {
                  staticStyle: { display: "block", margin: "0 auto" },
                  attrs: { width: "80%", src: _vm.dialogImageUrl, alt: "" },
                }),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("import-bill", {
        attrs: { show: _vm.autoVerifyBillDialog, info: _vm.autoVerifyBillInfo },
        on: {
          "update:show": function ($event) {
            _vm.autoVerifyBillDialog = $event
          },
          handleImpSts: _vm.handleImpSts,
        },
      }),
      _vm.tableConfigurationDialog
        ? _c("tableConfiguration", {
            ref: "mergeOrderDetail",
            attrs: {
              value: _vm.tableConfigurationDialog,
              data: _vm.tableConfigList,
              activeName: _vm.activeName,
            },
            on: { close: _vm.closeTableConfigurationDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }